<div class="d-flex flex-column">
  <app-floating-menu-button 
    *ngFor="let item of items" 
    [unclickedClass]="item.unclickedClass"
    [clickedClass]="item.clickedClass" 
    [visible]="item.type !== 'HIDE_UI' ? !this.hide : true"
    [clickeable]="item.clickeable"
    (onClick)="doAction(item)">
  </app-floating-menu-button>
</div>